module.exports = __webpack_public_path__ + "img/caratula_bambu.35cbdbc5.jpeg";